import type { ReactNode } from 'react';
import styles from './ProjectWorkspaceHeader.module.css';

type Props = {
  title: string;
  subtitle: ReactNode;
  projectName: string;
  onSwitchProject: () => void;
  actions?: ReactNode;
};

export function ProjectWorkspaceHeader({
  title,
  subtitle,
  projectName,
  onSwitchProject,
  actions,
}: Props) {
  return (
    <header className={`${styles.header} ${actions ? styles.headerWithActions : ''}`}>
      <div className={styles.main}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
        <div className={styles.projectRow}>
          <span className={styles.projectPill}>{projectName}</span>
          <button type="button" className={styles.switchProject} onClick={onSwitchProject}>
            Ander project
          </button>
        </div>
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
}
